// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuListItemGroup_children__YcY8h > * {
  padding-left: 14px;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.MenuListItemGroup_root__8bF9T {
  display: flex;
  align-items: center;
  height: 35px;
  border: 0;
  outline: none;
  background: transparent;
  width: 100%;
  cursor: pointer;
  box-sizing: content-box;
  padding-left: 0;
  padding-right: 0;
  transition: 0.3s all;
}
.MenuListItemGroup_root__8bF9T:hover {
  background: rgba(230, 230, 230, 0.6);
}

.MenuListItemGroup_icon__RHpBn {
  width: 35px;
  height: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
}

.MenuListItemGroup_label__-ViGG {
  display: inline-block;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #272A36;
  padding-right: 2px;
}

.MenuListItemGroup_arrow__ODDqO {
  margin-left: auto;
  margin-right: 16px;
  transition: 0.3s all;
  transform: rotate(180deg);
}
.MenuListItemGroup_arrowExpanded__ab9sg {
  transform: rotate(0deg);
}`, "",{"version":3,"sources":["webpack://./../../packages/sdk/src/components/ui/MenuList/MenuListItemGroup/MenuListItemGroup.module.scss"],"names":[],"mappings":"AAGE;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,YAbO;EAcP,SAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EAEA,oBAAA;AAJF;AAME;EACE,oCAAA;AAJJ;;AAQA;EACE,WA/BO;EAgCP,YAhCO;EAiCP,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AALF;;AAQA;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AALF;;AAQA;EACE,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;AALF;AAOE;EACE,uBAAA;AALJ","sourcesContent":["$height: 35px;\n\n.children {\n  & > * {\n    padding-left: 14px;\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n}\n\n.root {\n  display: flex;\n  align-items: center;\n  height: $height;\n  border: 0;\n  outline: none;\n  background: transparent;\n  width: 100%;\n  cursor: pointer;\n  box-sizing: content-box;\n  padding-left: 0;\n  padding-right: 0;\n\n  transition: 0.3s all;\n\n  &:hover {\n    background: rgba(230, 230, 230, 0.6);\n  }\n}\n\n.icon {\n  width: $height;\n  height: $height;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding-left: 3px;\n}\n\n.label {\n  display: inline-block;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  color: #272A36;\n  padding-right: 2px;\n}\n\n.arrow {\n  margin-left: auto;\n  margin-right: 16px;\n  transition: 0.3s all;\n  transform: rotate(180deg);\n\n  &Expanded {\n    transform: rotate(0deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"children": `MenuListItemGroup_children__YcY8h`,
	"root": `MenuListItemGroup_root__8bF9T`,
	"icon": `MenuListItemGroup_icon__RHpBn`,
	"label": `MenuListItemGroup_label__-ViGG`,
	"arrow": `MenuListItemGroup_arrow__ODDqO`,
	"arrowExpanded": `MenuListItemGroup_arrowExpanded__ab9sg`
};
export default ___CSS_LOADER_EXPORT___;
